export enum PaintMethod {
	INTERPOLATE = 'interpolate',
	COLOR = 'color',
}
